"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpeningImageBase = void 0;
const react_1 = require("react");
const PrintDPI_1 = require("../../../printing/PrintDPI");
const useProjectState_1 = require("../../useProjectState");
const useOpening_1 = __importStar(require("./useOpening"));
/**
 * The limits we place for the size an image can actually be scaled up or down in relation to the
 * size of the opening it is in.
 */
const MIN_RELATIVE_SCALE = 0.05;
const MAX_RELATIVE_SCALE = 10;
function useOpeningImageBase(openingFeature, openingInput, imageId) {
    const { outputScale, design } = (0, useProjectState_1.useProjectFile)();
    const { printLayer } = (0, useOpening_1.useOpeningBase)(openingFeature, openingInput);
    const depth = openingInput.images.findIndex(openingImage => openingImage.id === imageId);
    const image = openingInput.images[depth];
    /*
    const selected = openingInput.selectedImageId === image?.id;
    const highlighted = openingInput.highlightedImageId === image?.id;
    const lowlighted =
    openingInput.highlightedImageId &&
    openingInput.highlightedImageId !== image?.id;
    */
    const selected = false;
    const highlighted = false;
    const lowlighted = false;
    /* The scale of the image relative to the opening it is in. */
    const extremes = (0, react_1.useMemo)(() => {
        if (!image) {
            return {
                minWidth: 0,
                minHeight: 0,
                maxWidth: 0,
                maxHeight: 0,
            };
        }
        const imageAspectRatio = image.width / image.height;
        const printLayerAspectRatio = printLayer.bbox.width / printLayer.bbox.height;
        if (imageAspectRatio < printLayerAspectRatio) {
            // Use opening width as basis
            return {
                minWidth: printLayer.bbox.width * MIN_RELATIVE_SCALE,
                minHeight: (printLayer.bbox.width * MIN_RELATIVE_SCALE) / imageAspectRatio,
                maxWidth: printLayer.bbox.width * MAX_RELATIVE_SCALE,
                maxHeight: (printLayer.bbox.width * MAX_RELATIVE_SCALE) / imageAspectRatio,
            };
        }
        else {
            // Use opening height as basis
            return {
                minWidth: printLayer.bbox.height * MIN_RELATIVE_SCALE * imageAspectRatio,
                minHeight: printLayer.bbox.height * MIN_RELATIVE_SCALE,
                maxWidth: printLayer.bbox.height * MAX_RELATIVE_SCALE * imageAspectRatio,
                maxHeight: printLayer.bbox.height * MAX_RELATIVE_SCALE,
            };
        }
    }, [image, printLayer]);
    /* The DPI of the image when printed at it's current scale. */
    const printDpi = (0, react_1.useMemo)(() => {
        if (!image) {
            return 0;
        }
        return (0, PrintDPI_1.getPrintDPIFromOpeningImage)(image, outputScale);
    }, [image]);
    return Object.assign({ image,
        depth,
        selected,
        highlighted,
        lowlighted,
        printDpi }, extremes);
}
exports.useOpeningImageBase = useOpeningImageBase;
function useOpeningImage(openingId, imageId) {
    const { openingInput, openingFeature } = (0, useOpening_1.default)(openingId);
    return useOpeningImageBase(openingFeature, openingInput, imageId);
}
exports.default = useOpeningImage;
//# sourceMappingURL=data:application/json;base64,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